import { render } from "./Interventi.vue?vue&type=template&id=6160ee0e&scoped=true&ts=true"
import script from "./Interventi.vue?vue&type=script&lang=ts"
export * from "./Interventi.vue?vue&type=script&lang=ts"

import "./Interventi.vue?vue&type=style&index=0&id=6160ee0e&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_seilatv/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6160ee0e"]])

export default __exports__